export default __webpack_public_path__ + "static/media/addy.7b7bb2e4.svg";